import { useState } from 'react';
import { Button, DatePicker, Menu, Dropdown } from 'antd';
import ArrowBackDatePickerIcon from 'components/icons/ArrowBackDatePickerIcon';
import NextArrowDatePickerIcon from 'components/icons/NextArrowDatePickerIcon';
import 'moment/locale/es';
import MoreOptionsIcon from 'components/icons/MoreOptionsIcon';
import NextArrowIcon from 'components/icons/NextArrowIcon';
import es from 'antd/es/date-picker/locale/es_ES';

import Colors from 'assets/Colors';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import s from './styles';

function applyItemStyle(selected) {
  return {
    height: '45px',
    background: Colors.BG_MENU,
    color: selected && Colors.text_on_secondary,
    marginBottom: '10px',
    borderRadius: '2px',
  };
}

function generateDateRange(date, period) {
  if (period === 'range') {
    return {
      start: moment(date[0]).startOf('day'),
      end: moment(date[1]).endOf('day'),
    };
  }
  return {
    start: moment(date).startOf(period),
    end: moment(date).endOf(period),
  };
}

function CustomDatePicker({ value, onChange, loading: disabled }) {
  const { t } = useTranslation();

  const { RangePicker } = DatePicker;

  const [periodType, changePeriodType] = useState('date');

  const [typeCalendar, setTypeCalendar] = useState('date');

  const [openRangePicker, setOpenRangePicker] = useState(false);

  let format = 'D MMM YYYY';
  if (periodType === 'month') {
    format = 'MMM YYYY';
  } else if (periodType === 'quarter') {
    format = '[Q]Q YYYY';
  } else if (periodType === 'year') {
    format = 'YYYY';
  }

  const menu = (
    <Menu
      style={{
        overflow: 'auto',
        padding: '8px',
        paddingBottom: 0,
        minWidth: '147px',
        textAlign: 'center',
      }}
    >
      <Menu.Item
        key="yesterday"
        onClick={() => {
          changePeriodType('date');
          const date = moment().add(-1, 'days');
          onChange(date, 'date', generateDateRange(date, 'day'));
        }}
        style={applyItemStyle()}
      >
        {t('components.common.CustomDatePicker.yesterday')}
      </Menu.Item>

      <Menu.Item
        key="lastMonth"
        onClick={() => {
          changePeriodType('month');
          const date = moment().add(-1, 'months');
          onChange(date, 'month', generateDateRange(date, 'month'));
        }}
        style={applyItemStyle()}
      >
        {t('components.common.CustomDatePicker.lastMonth')}
      </Menu.Item>

      <Menu.Item
        key="lastQuarter"
        onClick={() => {
          changePeriodType('quarter');
          const date = moment().add(-1, 'quarter');
          onChange(date, 'quarter', generateDateRange(date, 'quarter'));
        }}
        style={applyItemStyle()}
      >
        {t('components.common.CustomDatePicker.lastQuarter')}
      </Menu.Item>

      <Menu.Item
        key="lastYear"
        onClick={() => {
          changePeriodType('year');
          const date = moment().add(-1, 'years');
          onChange(date, 'year', generateDateRange(date, 'year'));
        }}
        style={applyItemStyle()}
      >
        {t('components.common.CustomDatePicker.lastYear')}
      </Menu.Item>
    </Menu>
  );

  return (
    <s.Wrapper>
      <s.TextTitleWrapper>
        {`${t('components.common.CustomDatePicker.showTimeData')} `}

        {periodType === 'date'
          ? moment(value).format('LL')
          : periodType === 'quarter'
            ? `${moment(value).startOf('quarter').format('LL')} - ${moment(value)
              .endOf('quarter')
              .format('LL')}`
            : periodType === 'month'
              ? `${moment(value).startOf('month').format('LL')} - ${moment(value)
                .endOf('month')
                .format('LL')}`
              : periodType === 'year'
                ? `${moment(value).startOf('year').format('LL')} - ${moment(value)
                  .endOf('year')
                  .format('LL')}`
                : periodType === 'range'
                  ? `${moment(value[0]).locale('es').format('LL')} - ${moment(value[1])
                    .locale('es')
                    .format('LL')}`
                  : moment(value).format('LL')}
      </s.TextTitleWrapper>
      <s.WrapperBottomComponents>
        <s.DataTimeSelector disabled={disabled}>
          <s.DateTimeSelectorItem
            selected={periodType === 'date' || periodType === 'range'}
            left
            onClick={() => {
              const date = moment();
              changePeriodType('date');
              setTypeCalendar('date');
              onChange(date, 'date', generateDateRange(date, 'day'));
            }}
            style={{
              borderTopLeftRadius: '2px',
              borderBottomLeftRadius: '2px',
            }}
            nextSelected={periodType === 'month'}
          >
            {t('components.common.CustomDatePicker.day')}
          </s.DateTimeSelectorItem>

          <s.DateTimeSelectorItem
            selected={periodType === 'month'}
            onClick={() => {
              const date = moment();
              changePeriodType('month');
              setTypeCalendar('date');
              onChange(date, 'month', generateDateRange(date, 'month'));
            }}
            nextSelected={periodType === 'quarter'}
          >
            {t('components.common.CustomDatePicker.month')}
          </s.DateTimeSelectorItem>

          <s.DateTimeSelectorItem
            selected={periodType === 'quarter'}
            onClick={() => {
              const date = moment();
              changePeriodType('quarter');
              setTypeCalendar('date');
              onChange(date, 'quarter', generateDateRange(date, 'quarter'));
            }}
            nextSelected={periodType === 'year'}
          >
            {t('components.common.CustomDatePicker.quarter')}
          </s.DateTimeSelectorItem>

          <s.DateTimeSelectorItem
            selected={periodType === 'year'}
            onClick={() => {
              const date = moment();
              changePeriodType('year');
              setTypeCalendar('date');
              onChange(date, 'year', generateDateRange(date, 'year'));
            }}
          >
            {t('components.common.CustomDatePicker.year')}
          </s.DateTimeSelectorItem>
          <s.DateTimeSelectorItem
            style={{
              borderTopRightRadius: '2px',
              borderBottomRightRadius: '2px',
              padding: 0,
            }}
          >
            <Dropdown
              placement="bottomCenter"
              overlay={menu}
              trigger={['click']}
            >
              <s.MoreOptionsIconWrapper>
                <MoreOptionsIcon color={Colors.text_primary} />
              </s.MoreOptionsIconWrapper>
            </Dropdown>
          </s.DateTimeSelectorItem>
        </s.DataTimeSelector>

        <s.WrapperDatePicker
          disabled={disabled}
          range={typeCalendar === 'range'}
        >
          <s.IconArrowWrapper
            style={{ borderRight: `0.5px solid ${Colors.text_secondary}` }}
            onClick={() => {
              const date = moment(value).add(
                -1,
                `${periodType === 'date' ? 'days' : `${periodType}s`}`
              );
              onChange(
                date,
                periodType,
                generateDateRange(
                  date,
                  periodType === 'date' ? 'day' : `${periodType}`
                )
              );
            }}
          >
            <NextArrowIcon style={{ transform: 'rotate(180deg)' }} />
          </s.IconArrowWrapper>
          <div style={{ flex: 1 }} />

          {typeCalendar === 'range' ? (
            <RangePicker
              value={value}
              format={format}
              inputReadOnly
              showToday={false}
              open={openRangePicker}
              onOpenChange={(open) => setOpenRangePicker(open)}
              renderExtraFooter={() => (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Button
                    type="text"
                    onClick={() => [
                      setTypeCalendar('date'),
                      changePeriodType('date'),
                      onChange(
                        moment(),
                        'date',
                        generateDateRange(moment(), 'day')
                      ),
                    ]}
                  >
                    {t('components.common.CustomDatePicker.today')}
                  </Button>
                </div>
              )}
              style={{
                width: '100%',
                position: 'absolute',
                paddingLeft: '32px',
                paddingRight: '32px',
                height: '40px',
              }}
              allowClear={false}
              onChange={(val) => {
                onChange(
                  val,
                  periodType,
                  generateDateRange(
                    val,
                    periodType === 'date' ? 'day' : `${periodType}`
                  )
                );
                setOpenRangePicker(false);
              }}
              bordered={false}
              locale={es}
              suffixIcon=""
              picker={periodType}
            />
          ) : (
            <DatePicker
              value={value}
              format={format}
              inputReadOnly
              showToday={false}
              renderExtraFooter={() => {
                if (periodType == 'date') {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Button
                        type="text"
                        onClick={() => [
                          setTypeCalendar('date'),
                          changePeriodType('date'),
                          setOpenRangePicker(false),
                          onChange(
                            moment(),
                            'date',
                            generateDateRange(moment(), 'day')
                          ),
                        ]}
                      >
                        {t('components.common.CustomDatePicker.today')}
                      </Button>
                      <Button
                        type="text"
                        onClick={() => [
                          setTypeCalendar('range'),
                          changePeriodType('range'),
                          setOpenRangePicker(true),
                        ]}
                      >
                        {t('components.common.CustomDatePicker.range')}
                      </Button>
                    </div>
                  );
                }
              }}
              style={{
                width: '100%',

                position: 'absolute',
                paddingLeft: '32px',
                paddingRight: '32px',
                height: '40px',
              }}
              allowClear={false}
              onChange={(val) => {
                const date = moment(val);
                onChange(
                  date,
                  periodType,
                  generateDateRange(
                    date,
                    periodType === 'date' ? 'day' : `${periodType}`
                  )
                );
              }}
              bordered={false}
              locale={es}
              nextIcon={
                periodType === 'date' || periodType === 'week' ? (
                  <NextArrowDatePickerIcon style={{ margin: '0px 9px' }} />
                ) : (
                  ''
                )
              }
              prevIcon={
                periodType === 'date' || periodType === 'week' ? (
                  <ArrowBackDatePickerIcon style={{ margin: '0px 9px' }} />
                ) : (
                  ''
                )
              }
              superNextIcon={
                periodType === 'month' || periodType === 'year' ? (
                  <NextArrowDatePickerIcon style={{ margin: '0px 9px' }} />
                ) : (
                  ''
                )
              }
              superPrevIcon={
                periodType === 'month' || periodType === 'year' ? (
                  <ArrowBackDatePickerIcon style={{ margin: '0px 9px' }} />
                ) : (
                  ''
                )
              }
              suffixIcon=""
              picker={periodType}
            />
          )}

          <s.IconArrowWrapper
            style={{ borderLeft: `0.5px solid ${Colors.text_secondary}` }}
            onClick={() => {
              const date = moment(value).add(
                +1,
                `${periodType === 'date' ? 'days' : `${periodType}s`}`
              );
              onChange(
                date,
                periodType,
                generateDateRange(
                  date,
                  periodType === 'date' ? 'day' : `${periodType}`
                )
              );
            }}
          >
            <NextArrowIcon />
          </s.IconArrowWrapper>
        </s.WrapperDatePicker>
      </s.WrapperBottomComponents>
    </s.Wrapper>
  );
}

export default CustomDatePicker;
